import { useEffect, useState } from "react";
import LHeader from "../lheader/LHeader";
import {
  ComponentCmsDataHeaderSection,
  useGetPagesHeaderQuery,
} from "@/generated";
import WDataWrapper from "../wdata-wrapper/WDataWrapper";

/* eslint-disable-next-line */
export interface LDefaultLayoutProps {
  children: any;
}

export function LDefaultLayout(props: LDefaultLayoutProps) {
  //get the home page header
  const {
    data: headerData,
    loading: headerLoading,
    error: headerError,
  } = useGetPagesHeaderQuery({
    variables: {
      filters: {
        slug: {
          eq: "landing-home-page",
        },
      },
    },
  });

  const [homePageHeader, setHomePageHeader] =
    useState<ComponentCmsDataHeaderSection>();

  useEffect(() => {
    const homePageHeader =
      headerData?.pages?.data?.[0]?.attributes?.components?.find(
        (component) => component?.__typename === "ComponentCmsDataHeaderSection"
      );
    setHomePageHeader(homePageHeader as ComponentCmsDataHeaderSection);
  }, [headerData?.pages?.data]);

  return (
    <WDataWrapper
      isData={!!headerData}
      isLoading={headerLoading}
      isError={headerError}
      skeletonType="none"
    >
      <div className="web-landing-v2">
        <LHeader
          image={{
            url: homePageHeader?.image?.data?.attributes?.url ?? "",
            altTag:
              homePageHeader?.image?.data?.attributes?.alternativeText ?? "",
          }}
          button={{
            text: homePageHeader?.button?.text ?? "",
            url: homePageHeader?.button?.url ?? "",
          }}
        />
        {props?.children}
      </div>
    </WDataWrapper>
  );
}

export default LDefaultLayout;
